export default __webpack_public_path__ + "static/media/bang-cap-11_11.430949da.jpg";